export default __webpack_public_path__ + "static/media/img-0771-sweden-full-face.5b73e83a.png";